export const dishes = [
  {
    id: "arroz-camaron",
    name: "ARROZ CON CAMARÓN Y PESCADO",
    price: "$39.000",
    description:
      "Pescado y camarón integrados en arroz de aromas tostados, terminado con ahumado al carbón, notas de coco y plátano maduro y chicharrón crocante.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20fine%20dining%20photograph%20of%20seafood%20rice%20with%20shrimp%20and%20fish%20served%20in%20a%20dark%20handmade%20ceramic%20bowl%2C%20warm%20amber%20side%20lighting%2C%20smoky%20charcoal%20finish%2C%20coconut%20and%20caramelized%20plantain%20notes%2C%20crispy%20crackling%20garnish%2C%20black%20slate%20table%2C%20moody%20restaurant%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20rich%20warm%20tones&width=800&height=600&seq=clem-dish-arroz-camaron&orientation=landscape",
  },
  {
    id: "panza-caramelo",
    name: "PANZA CARAMELO",
    price: "$30.000",
    description:
      "Panza de cerdo de cocción lenta, tierna en su interior y sutilmente crocante por fuera, glaseada hasta alcanzar un profundo carácter umami y caramelizada, acompañada de arroz blanco, ajonjolí y cebolla verde.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20slow%20cooked%20caramelized%20pork%20belly%20glazed%20and%20shiny%2C%20crispy%20outside%20and%20tender%20inside%2C%20served%20with%20white%20rice%2C%20sesame%20seeds%20and%20green%20onion%2C%20dark%20artisanal%20plate%2C%20warm%20amber%20lighting%2C%20black%20stone%20table%2C%20moody%20fine%20dining%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=clem-dish-panza-caramelo&orientation=landscape",
  },
  {
    id: "seiseizushi",
    name: "SEISEIZUSHI",
    price: "$35.000",
    description:
      "Salmón premium sobre timbal de arroz de sushi, mayonesa japonesa, notas marinas de kombu y yacón.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20premium%20salmon%20sashimi%20over%20a%20sushi%20rice%20timbal%20with%20japanese%20mayonnaise%2C%20delicate%20seaweed%20notes%2C%20elegant%20plating%20on%20a%20dark%20ceramic%20dish%2C%20warm%20amber%20lighting%2C%20black%20slate%20table%2C%20moody%20fine%20dining%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=clem-dish-seiseizushi&orientation=landscape",
  },
  {
    id: "rib-eye-sichuan",
    name: "RIB EYE EN SALSA SICHUAN",
    price: "$130.000",
    description:
      "400 gramos de rib eye ahumado, acompañado de una salsa de autor de perfil profundo y untuoso con notas de miso, cebolla caramelizada y brandy, equilibradas por el carácter especiado de sichuan.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20a%20smoked%20rib%20eye%20steak%20sliced%20with%20a%20glossy%20dark%20miso%20caramelized%20onion%20sauce%2C%20fresh%20herbs%2C%20served%20on%20a%20dark%20artisanal%20plate%2C%20warm%20amber%20lighting%2C%20black%20stone%20table%2C%20moody%20fine%20dining%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=clem-dish-ribeye-sichuan&orientation=landscape",
  },
  {
    id: "milanesa-pollo",
    name: "MILANESA DE POLLO",
    price: "$38.000",
    description:
      "Milanesa de pollo crocante con salsa de anchoa, lechuga, queso parmesano y ajonjolí.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20a%20crispy%20breaded%20chicken%20cutlet%20milanesa%20with%20anchovy%20sauce%2C%20fresh%20lettuce%2C%20parmesan%20cheese%20and%20sesame%20seeds%2C%20elegant%20plating%20on%20a%20dark%20ceramic%20plate%2C%20warm%20amber%20lighting%2C%20black%20slate%20table%2C%20moody%20fine%20dining%20editorial%20photography&width=800&height=600&seq=clem-dish-milanesa-pollo&orientation=landscape",
  },
  {
    id: "corona-pescado",
    name: "CORONA DE PESCADO BLANCO",
    price: "$28.000",
    description:
      "Pescado blanco de temporada y centro de aguachile fresco que aporta acidez, aroma y equilibrio, con queso parmesano, crema de queso, plátano maduro, vinagre de arroz y flores de papa.",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20photograph%20of%20white%20fish%20with%20a%20fresh%20aguachile%20center%2C%20parmesan%20cream%2C%20ripe%20plantain%20and%20potato%20blossoms%2C%20delicate%20elegant%20plating%20on%20a%20dark%20artisanal%20plate%2C%20warm%20amber%20lighting%2C%20black%20slate%20table%2C%20moody%20fine%20dining%20editorial%20photography&width=800&height=600&seq=clem-dish-corona-pescado&orientation=landscape",
  },
];

export const dishesNote =
  "Precios en pesos colombianos, incluyen impuesto al consumo del 8%.";